import { useState } from 'react';

import { getLoteFields } from 'components/GetFields/Lote';
import List from 'components/List';
import { useAuth } from 'contexts/auth';
import { getSexo } from 'utils/getSexoOption';

export default function Lotes() {
  const { selectedFazenda } = useAuth();
  const [lote, setLote] = useState({} as any);

  return (
    <div>
      <List
        title="Lotes"
        table="lote"
        selected={lote}
        setSelected={setLote}
        idColumn="codLote"
        columns={[
          {
            title: 'Nome',
            field: 'nome',
            width: 0,
            cellStyle: { whiteSpace: 'normal' },
            defaultSort: 'asc',
          },
          {
            title: 'Descrição',
            field: 'descricao',
            width: 0,
            cellStyle: { whiteSpace: 'normal' },
            render: (rowData) => rowData?.descricao ?? '-',
          },
          {
            title: 'Abreviação',
            field: 'abreviacao',
            width: 0,
            cellStyle: { whiteSpace: 'normal' },
            render: (rowData) => rowData?.abreviacao ?? '-',
          },
          {
            title: 'Fase',
            field: 'fase.nome',
            width: 0,
            cellStyle: { whiteSpace: 'normal' },
            render: (rowData) => rowData?.fase?.nome ?? '-',
          },
          {
            title: 'Sexo dos Animais',
            field: 'sexo',
            width: 0,
            cellStyle: { whiteSpace: 'normal' },
            render: (rowData: any) => getSexo(rowData?.sexo),
          },
        ]}
        data={`/lotes/getByFazenda/${selectedFazenda?.codFazenda}`}
        getFields={getLoteFields}
      />
    </div>
  );
}
